export default "__VITE_ASSET__2mRh86MG__"